import { useEffect, useState } from "react";
import { useDetailsFilled } from "../../../hooks/useDetailsFilled";
import { useTaxes } from "../../../hooks/useTaxes";
import ILocationAPIObject from "../../../interfaces/ILocationAPI";
import IVenueSettings from "../../../interfaces/IVenueSettings";
import { HTTPMethods } from "../../../services/API";
import IVenue from "../../../yoello-lib/modules/API/interfaces/IVenue";
import APIExtensions from "../../../yoello-lib/modules/API2/APIDefs";
import { useAPIV2 } from "../../../yoello-lib/modules/API2/useAPIv2";



/**Handles the venues startup data */
export function useVenueStartup(venue: IVenue | undefined | null) {
    const { callAPI: callSettings } = useAPIV2<IVenueSettings>(APIExtensions.venueSettings,
        {
            selectorKeyParams: { venue_id: venue?.id }, yoelloAPIParams: { venue_id: venue?.id, include_disabled: true, include_hidden: true }, dispatcherParams: [venue?.id!], onMountDisabled: true
        });
    const { callAPI: callLocations } = useAPIV2<ILocationAPIObject>(APIExtensions.locations,
        { selectorKeyParams: { venue_id: venue?.id }, dispatcherParams: [venue?.id!], query: venue?.location_id, onMountDisabled: true });

    const { callAPI: callVenueFees } = useAPIV2(APIExtensions.venueFees,
        {
            selectorKeyParams: { venue_id: venue?.id }, yoelloAPIParams: { venue_id: venue?.id, include_disabled: true }, dispatcherParams: [venue?.id!], onMountDisabled: true
        });
    const [isCompleted, setIsCompleted] = useState(false);
    const [isFailed, setIsFailed] = useState(false);

    /**hook for detecting if on old tax model */
    useTaxes(venue?.id!);
    /**Hook for detecting if details are filled */
    useDetailsFilled();

    useEffect(() => {
        if (!venue) return;
        const workload = [];
        /**Whenever the venue changes lets get the locations/settings */
        workload.push(callLocations(HTTPMethods.GET, {
            canAPIGetCacheValue: false,
            selectorKeyParams: { venue_id: venue.id },
            dispatcherParams: [venue.id!], query: venue.location_id
        }));
        workload.push(callSettings(HTTPMethods.GET, {
            canAPIGetCacheValue: false,
            selectorKeyParams: { venue_id: venue.id },
            yoelloAPIParams: { venue_id: venue.id, include_disabled: true },
            dispatcherParams: [venue.id!]
        }));
        workload.push(callVenueFees(HTTPMethods.GET, {
            canAPIGetCacheValue: false,
            selectorKeyParams: { venue_id: venue.id },
            yoelloAPIParams: { venue_id: venue.id, include_disabled: true },
            dispatcherParams: [venue.id!]
        }));
        Promise.all(workload).then((res) => {
            const count = res.reduce((prevItem, nextItem) => {
                return prevItem + (nextItem.isSuccessful ? 1 : 0)
            }, 0);
            console.log({ count });

            if (count === res.length) {
                setIsCompleted(true);
            } else {
                setIsFailed(true)
            }
        })
        // eslint-disable-next-line
    }, [venue]);
    return {
        isCompleted,
        isFailed
    }
}
